var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-modal',{attrs:{"show":_vm.showAmount,"type":"tag","title":"贡献奖励","iconType":"gift_2"},on:{"close":function($event){return _vm.hideModal()}}},[_c('div',{staticClass:"bonus"},[_c('div',{staticClass:"bg"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }